import React, {useEffect, useState} from 'react';
import UserUpdateProfileComponent from '../../../Components/UserComponents/UserUpdateProfile';
import {
  fetchUsersByIdForUpdateProfile,
  getAllChapters,
  getAllKeywordsByQuery,
  resetKeywordSearchData,
  updateUserById,
} from '../../../Store/Actions';
import {
  appendOtherChapterOption,
  createSelectionOptionsUtil,
  getLocalStorageUserInfo,
  getVisibleChapters,
  queryString,
  resolveOtherChapter,
} from '../../../Util/commonUtility';
import {useDispatch, useSelector} from 'react-redux';
import useLocalization from '../../../Localization';

const UserUpdateProfileContainer = () => {
  const dispatch = useDispatch();
  const {ApplicationString} = useLocalization();
  const {fetchUserDataForUpdateProfile} = useSelector(({users}) => users);
  const {allChapters} = useSelector(({chapters}) => chapters);
  const {allKeywordsQueryData} = useSelector(({keywords}) => keywords);
  const [userData, setUserData] = useState([]);
  const [localChaptersList, setLocalChaptersList] = useState([]);
  const [mailPreferenceChaptersList, setMailPreferenceChaptersList] =
    useState([]);
  const [otherChapterId, setOtherChapterId] = useState(null);
  const [keywordsOptions, SetKeywordsOptions] = useState([]);
  const userInfo = getLocalStorageUserInfo();
  const userId = userInfo?.id;

  useEffect(() => {
    dispatch(resetKeywordSearchData(false));
  }, []);

  useEffect(() => {
    if (fetchUserDataForUpdateProfile) {
      setUserData(fetchUserDataForUpdateProfile?.data);
    } else {
      dispatch(fetchUsersByIdForUpdateProfile(userId));
    }
  }, [fetchUserDataForUpdateProfile?.data]);

  useEffect(() => {
    if (allChapters) {
      const chapters = allChapters?.data?.chapters ?? [];
      const visibleChapters = getVisibleChapters(chapters);
      setLocalChaptersList(
        appendOtherChapterOption(
          createSelectionOptionsUtil(visibleChapters, 'id', 'name'),
          chapters,
        ),
      );
      setMailPreferenceChaptersList(
        createSelectionOptionsUtil(visibleChapters, 'id', 'name'),
      );
      setOtherChapterId(resolveOtherChapter(chapters)?.id ?? null);
    } else {
      dispatch(getAllChapters());
    }
  }, [allChapters]);

  useEffect(() => {
    if (allKeywordsQueryData.forMaster) {
      SetKeywordsOptions(
        createSelectionOptionsUtil(
          allKeywordsQueryData.forMaster?.data?.keywords,
          'id',
          'name',
        ),
      );
    } else {
      dispatch(
        getAllKeywordsByQuery('name', 'ascend', queryString({status: 1}), {
          page: 1,
          pageCount: 1000,
        }),
      );
    }
  }, [allKeywordsQueryData.forMaster]);

  const updateUser = async (Data, id, Navigate) => {
    const updateProfileText = ApplicationString['userUpdateProfileComponent.update_profile_success'];
    dispatch(updateUserById(Data, id, Navigate, updateProfileText));
  };

  return (
    <UserUpdateProfileComponent
      localChaptersList={localChaptersList}
      mailPreferenceChaptersList={mailPreferenceChaptersList}
      otherChapterId={otherChapterId}
      userData={userData}
      updateUser={(id, Data, Navigate) => {
        updateUser(id, Data, Navigate);
      }}
      keywordsOptions={keywordsOptions}
    />
  );
};

export default UserUpdateProfileContainer;



